import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import StockIndentService from "../services/stockIndentService";

export default function ViewStockIndentDetails() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetchDetails();
  }, [id]);

  const fetchDetails = async () => {
    try {
      const res = await StockIndentService.getById(id);
      const payload = res?.data?.data || {};
      setRows(payload.details || []);
    } catch {
      setRows([]);
    }
  };

  return (
    <>
      <Breadcrumb pageTitle="StockIndentDetails" secondTitle="Inventory" />

      <button className="btn btn-secondary m-2" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <div className="card p-3 bg-white shadow-sm">
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Item</th>
              <th>UOM</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {rows.length ? rows.map((row, i) => (
              <tr key={i}>
                <td>{row.itemCode}</td>
                <td>{row.UOM || row.uom || row.uomName || "-"}</td>
                <td>{row.quantity}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan="3" className="text-center">No records found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
